import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Deadline = styled.span(() =>
  mq({
    color: defaultTheme.color.primary,
    fontWeight: 'bold',
  }),
);
